import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Home from "./pages/Home";
import ForgetPassword from "./pages/auth/ForgetPassword";
import Register from "./pages/auth/Register";
import AccountTransaction from "./pages/AccountTransaction";
import Analytics from "./pages/Analytics";
import Blogdetails from "./pages/Blogdetails";
import Demoaccount from "./pages/Demoaccount";
import DepositTether from "./pages/DepositTether";
import Faq from "./pages/Faq";
import IbDashboard from "./pages/IbDashboard";
import KycDocuments from "./pages/KycDocuments";
import LeverageHistory from "./pages/LeverageHistory";
import LiveAccountDashboard from "./pages/LiveAccountDashboard";
import Overview from "./pages/Overview";
import Report from "./pages/Report";
import Tickets from "./pages/Tickets";
import Transaction from "./pages/Transaction";
import Transfer from "./pages/Transfer";
import Wallet from "./pages/Wallet";
import WithdrawTether from "./pages/WithdrawTether";
import Withdraw from "./pages/Withdraw";
import CryptoWithdraw from "./pages/CryptoWithdraw";
import WithdrawHistory from "./pages/WithdrawHistory";
import Withdrawal from "./pages/Withdrawal";
import WithdrawWallet from "./pages/WithdrawWallet";
import LiveAccount from "./pages/LiveAccount";
import Deposit from "./pages/Deposit";
import Deposit_wallet from "./pages/Deposit_wallet";
import Dashboard2 from "./pages/Dashboard2";
import Login from "./pages/auth/Login";
import Profile from "./pages/Profile"
import ResetPassword from "./pages/auth/ResetPassword";
import PrivateRouter from "./component/PrivateRouter";
import QuickLinks from "./pages/QuickLinks";
import { Toaster } from "react-hot-toast";
import ChangePassword from "./pages/ChangePassword";
import InvestorPassword from "./pages/InvestorPassword";
import MasterPassword from "./pages/MasterPassword";
import TicketInformation from "./pages/TicketInformation";
import IbCommissionReport from "./pages/IbCommissionReport";
import PublicRouter from "./component/PublicRouter";
import Notification from "./pages/Notification";
import ScrollTop from "./component/ScrollTop";
import PageNotFound from "./pages/PageNotFound";
import LiveTrades from "./pages/LiveTrades";
import TradeHistory from "./pages/TradeHistory";
import { UserProvider } from "./context/UserContext";
import DirectIncome from "./pages/DirectIncome";
import ProfitIncome from "./pages/ProfitIncome";
import IbIncome from "./pages/IbIncome";
import CpaHistory from "./pages/CpaHistory";
import IbPendingList from "./pages/IbPendingList";
import CryptoDeposit from "./pages/CryptoDeposit";
import CryptoDepositHistory from "./pages/CryptoDepositHistory";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import BankDetails from "./pages/BankDetails";
import News from "./pages/News";
import DeviceManagement from "./pages/DeviceManagement";
import Security from "./pages/Security";
import BecomeIb from "./pages/BecomeIb";
import BonusPrograms from "./pages/BonusPrograms";
import BonusHistory from "./pages/BonusHistory";
import ClaimHistory from "./pages/ClaimHistory";
import LearnAndEarn from "./pages/LearnAndEarn";
import PointDetails from "./pages/PointDetails";
import TradeAndEarn from "./pages/TradeAndEarn";
import Leaderboard from "./pages/CopyTrading/Leaderboard";
import MasterTraders from "./pages/CopyTrading/MasterTraders";
import TraderProfile from "./pages/CopyTrading/TraderProfile";
import Subscribe from "./pages/CopyTrading/Subscribe";
import MyCopiers from "./pages/CopyTrading/MyCopiers";
import MyMasters from "./pages/CopyTrading/MyMasters";
import PammTrading from "./pages/PammTrading";
import CreatePammStrategy from "./pages/CreatePammStrategy";
import PammStrategyDetails from "./pages/pamm/PammStrategyDetails";
import { TradingAccountProvider } from "./context/TradingAccountContext";
import Watchlist from "./pages/Watchlist";
import Position from "./pages/Position";
import PendingOrder from "./pages/PendingOrder";
import OrderHistory from "./pages/OrderHistory";
import Terminal from "./pages/Terminal";
import TradingLayout from "./component/trading/TradingLayout";
import "./App.css";

function App() {
  const userData = JSON.parse(Cookies.get("userdata") || "{}");
  // console.log("userData", userData);

  return (

    <BrowserRouter>
      <ScrollTop />
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      <Routes>
        <Route element={<PublicRouter />}>
          <Route path="/" index element={<Login />} />
          <Route path="/sys-adm-9x7q/:mid" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgetpassword" element={<ForgetPassword />} />
          <Route path="/reset_password" element={<ResetPassword />} />
        </Route>

        <Route element={<UserProvider><TradingAccountProvider><PrivateRouter /></TradingAccountProvider></UserProvider>}>
          <Route path="/dashboard" element={<Home />} />
          <Route path="/account_transaction" element={<AccountTransaction />} />
          <Route path="/user_transfer_history" element={<AccountTransaction defaultTab="user" />} />
          {/* <Route path="/analytics" element={<Analytics />} /> */}
          <Route path="/blog_details" element={<Blogdetails />} />
          <Route path="/demo_account" element={<Demoaccount />} />
          <Route path="/deposit_tether" element={<DepositTether />} />
          {/* <Route path="/faq" element={<Faq />} /> */}
          <Route path="/become-ib" element={<BecomeIb />} />
          <Route path="/ib_dashboard" element={<IbDashboard />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/withdrawal" element={<Withdrawal />} />
          <Route path="/report" element={<Report />} />
          <Route path="/ib_commission_report" element={<IbCommissionReport />} />
          <Route path="/kyc_documents" element={<KycDocuments />} />
          <Route path="/leverage_history" element={<LeverageHistory />} />
          <Route path="/live_account_dashboard" element={<LiveAccountDashboard />} />
          <Route path="/trade_history" element={<TradeHistory />} />
          {/* <Route element={<TradingLayout />}>
            <Route path="/terminal" element={<Terminal />} />
            <Route path="/watchlist" element={<Watchlist />} />
            <Route path="/position" element={<Position />} />
            <Route path="/pending-order" element={<PendingOrder />} />
            <Route path="/order-history" element={<OrderHistory />} />
          </Route> */}
          <Route path="/live_trades" element={<LiveTrades />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/transaction" element={<Transaction />} />
          <Route path="/transfer" element={<Transfer />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/withdraw_tether" element={<WithdrawTether />} />
          {/* Old withdraw page preserved untouched */}
          {/* <Route path="/withdraw_old" element={<Withdraw />} /> */}
          <Route path="/withdraw" element={<CryptoWithdraw />} />
          <Route path="/withdraw-history" element={<WithdrawHistory />} />
          <Route path="/crypto_withdraw" element={<CryptoWithdraw />} />
          <Route path="/crypto_withdraw_history" element={<WithdrawHistory />} />
          <Route path="/withdraw_Wallet" element={<WithdrawWallet />} />
          <Route path="/live_account" element={<LiveAccount />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/deposit_wallet" element={<Deposit_wallet />} />
          <Route path="/bank-details" element={<BankDetails />} />
          <Route path="/bank_details" element={<BankDetails />} />
          <Route path="/add_bank_details" element={<BankDetails />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<News />} />
          <Route path="/dashboard2" element={<Dashboard2 />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/security" element={<Security />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/device-management" element={<DeviceManagement />} />
          <Route path="/devices" element={<DeviceManagement />} />
          <Route path="/quick-links" element={<QuickLinks />} />
          <Route path="/investorpassword" element={<InvestorPassword />} />
          <Route path="/masterpassword" element={<MasterPassword />} />
          <Route path="/ticketinformation" element={<TicketInformation />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/notifications" element={<Notification />} />
          {/* <Route path="/direct-income" element={<DirectIncome />} /> */}
          {/* <Route path="/profit-income" element={<ProfitIncome />} /> */}
          <Route path="/ib-income" element={<IbIncome />} />
          <Route path="/cpa-history" element={<CpaHistory />} />
          <Route path="/cpa_history" element={<CpaHistory />} />
          <Route path="/ib-pending-list" element={<IbPendingList />} />
          <Route path="/ib_pending_list" element={<IbPendingList />} />
          <Route path="/crypto_deposit" element={<CryptoDeposit />} />
          <Route path="/crypto_deposit_history" element={<CryptoDepositHistory />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="/bonus-programs" element={<BonusPrograms />} />
          <Route path="/bonus-program" element={<BonusPrograms />} />
          <Route path="/bonus-history" element={<BonusHistory />} />
          <Route path="/bonus_history" element={<BonusHistory />} />
          <Route path="/claim-history" element={<ClaimHistory />} />
          <Route path="/claim_history" element={<ClaimHistory />} />
          <Route path="/learn-and-earn" element={<LearnAndEarn />} />
          <Route path="/learn_and_earn" element={<LearnAndEarn />} />
          <Route path="/point-details" element={<PointDetails />} />
          <Route path="/trade-and-earn" element={<TradeAndEarn />} />
          <Route path="/trade_and_earn" element={<TradeAndEarn />} />
          {/* Copy Trading Routes (Commented out) */}
          {/* <Route path="/copy-trading" element={<Leaderboard />} />
          <Route path="/copy-trading/leaderboard" element={<Leaderboard />} />
          <Route path="/copy-trading/master-traders" element={<MasterTraders />} />
          <Route path="/copy-trading/trader/:id" element={<TraderProfile />} />
          <Route path="/copy-trading/subscribe" element={<Subscribe />} />
          <Route path="/copy-trading/my-copiers" element={<MyCopiers />} />
          <Route path="/copy-trading/my-masters" element={<MyMasters />} /> */}

          {/* <Route path="/pamm-trading" element={<PammTrading defaultTab="leaderboard" />} />
          <Route path="/pamm-leaderboard" element={<PammTrading defaultTab="leaderboard" />} />
          <Route path="/pamm-subscribed" element={<PammTrading defaultTab="subscribed" />} />
          <Route path="/pamm-published" element={<PammTrading defaultTab="published" />} />
          <Route path="/pamm-create-strategy" element={<CreatePammStrategy />} />
          <Route path="/pamm-details/:id" element={<PammStrategyDetails />} />
          <Route path="/pamm/details/:id" element={<PammStrategyDetails />} />
          <Route path="*" element={<PageNotFound />} /> */}

        </Route>
      </Routes>

    </BrowserRouter >

  );
}

export default App;
